import BaseBlockContent from '@sanity/block-content-to-react'
import React from 'react'
import serializers from '../utils/serializers'

const BlockContent = ({ blocks }) =>
  blocks ? <BaseBlockContent blocks={blocks} serializers={serializers} /> : null

export default BlockContent
